/* eslint-disable */
import ko from 'knockout';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/upgraded-url');
var AdvancedSettingsUrlOptions = function (options) {
  this.isVisible = ko.observable(options.isVisible);
  this.isExpanded = ko.observable(options.isExpanded);
  this.editMode = ko.observable(options.editMode);
  this.parameters = ko.observableArray();
  this.trackingTemplate = ko.observable();
  this.finalUrlSuffix = ko.observable();
  this.isUrlCustomParametersSettingsExpanded = ko.observable(false);
  this.isTrackingTemplateSettingsExpanded = ko.observable(false);
  this.isFinalUrlSuffixSettingsExpanded = ko.observable(false);
  this.isFinalURLSuffixEnabled = ko.observable(options.isFinalURLSuffixEnabled);
  this.expanderLabel = function () {
    var ret;
    switch (options.entityType) {
      case 'Campaign':
      case 'campaign':
        ret = i18n.get('CampaignUrlOptions_AdvancedSettings_ExpanderLabel');
        break;
      case 'AdGroup':
      case 'adgroup':
        ret = i18n.get('AdGroupUrlOptions_AdvancedSettings_ExpanderLabel');
        break;
      case 'Ad':
        ret = i18n.get('AdUrlOptions_AdvancedSettings_ExpanderLabel');
        break;
      case 'SiteLinkAdExtension':
        ret = i18n.get('SiteLinkUrlOptions_AdvancedSettings_ExpanderLabel');
        break;
      default:
        ret = i18n.get('UrlOptions_AdvancedSettings_ExpanderLabel');
        break;
    }
    return ret;
  };
};
export default AdvancedSettingsUrlOptions;

